import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Share2, Loader2 } from "lucide-react";
import { useShareableLink } from "@/hooks/useShareableLink";
import ShareDialog from "@/components/shared/ShareDialog";

interface ShareButtonProps {
  entityType: string;
  entityId: string;
  title: string;
  subtitle?: string;
  className?: string;
}

export default function ShareButton({
  entityType,
  entityId,
  title,
  subtitle,
  className,
}: ShareButtonProps) {
  const [open, setOpen] = useState(false);
  const { shareUrl, isLoading, createLink, isCreating } = useShareableLink(
    entityType,
    entityId,
  );

  const handleClick = async () => {
    if (shareUrl) {
      setOpen(true);
      return;
    }

    // Auto-create the link if it doesn't exist yet
    await createLink({ title, subtitle });
    setOpen(true);
  };

  const loading = isLoading || isCreating;

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        className={className}
        onClick={handleClick}
        disabled={loading}
        aria-label="Dela"
      >
        {loading ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <Share2 className="h-4 w-4" />
        )}
      </Button>

      {shareUrl && (
        <ShareDialog
          url={shareUrl}
          title={title}
          subtitle={subtitle}
          open={open}
          onOpenChange={setOpen}
        />
      )}
    </>
  );
}
